import AccountBalanceWalletTwoToneIcon from "@mui/icons-material/AccountBalanceWalletTwoTone";
import AssignmentIndTwoToneIcon from "@mui/icons-material/AssignmentIndTwoTone";
import AccountCircleTwoToneIcon from "@mui/icons-material/AccountCircleTwoTone";
import PaymentTwoToneIcon from "@mui/icons-material/PaymentTwoTone";
import PaymentsTwoToneIcon from "@mui/icons-material/PaymentsTwoTone";
import ConfirmationNumberTwoToneIcon from "@mui/icons-material/ConfirmationNumberTwoTone";
import DescriptionTwoToneIcon from "@mui/icons-material/DescriptionTwoTone";
import VerticalSplitTwoToneIcon from "@mui/icons-material/VerticalSplitTwoTone";
import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
import ReceiptTwoToneIcon from "@mui/icons-material/ReceiptTwoTone";
import SupervisorAccountTwoToneIcon from "@mui/icons-material/SupervisorAccountTwoTone";
import AutorenewTwoToneIcon from "@mui/icons-material/AutorenewTwoTone";
import BusinessTwoToneIcon from "@mui/icons-material/BusinessTwoTone";
import ArticleTwoToneIcon from "@mui/icons-material/ArticleTwoTone";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import SwitchAccountTwoToneIcon from "@mui/icons-material/SwitchAccountTwoTone";
import SettingsEthernetTwoToneIcon from "@mui/icons-material/SettingsEthernetTwoTone";
import TollTwoToneIcon from "@mui/icons-material/TollTwoTone";
import ArrowCircleUpTwoToneIcon from "@mui/icons-material/ArrowCircleUpTwoTone";
import ArrowCircleDownTwoToneIcon from "@mui/icons-material/ArrowCircleDownTwoTone";
import MonetizationOnTwoToneIcon from "@mui/icons-material/MonetizationOnTwoTone";
import ShareTwoToneIcon from "@mui/icons-material/ShareTwoTone";
import PendingActionsTwoToneIcon from "@mui/icons-material/PendingActionsTwoTone";
import CorporateFareTwoToneIcon from "@mui/icons-material/CorporateFareTwoTone";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import SchemaTwoToneIcon from "@mui/icons-material/SchemaTwoTone";

import {
  ContactsTwoTone,
  ManageAccountsTwoTone,
  ManageSearchTwoTone,
  PolicyTwoTone,
  SavingsTwoTone,
  WebhookTwoTone,
} from "@mui/icons-material";
import RequestQuoteTwoToneIcon from "@mui/icons-material/RequestQuoteTwoTone";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

import {
  AccountTreeTwoTone,
  CampaignTwoTone,
  ReceiptLong,
  TimelapseTwoTone,
  TimelineTwoTone,
  TuneTwoTone,
  ViewAgendaTwoTone,
} from "@mui/icons-material";

const menuItems = [
  {
    heading: "Dashboard",
    items: [
      {
        name: "Home",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "sales",
          "compliance",
          "invoice",
          "finance",
          "tos",
          "presales_intern",
          "manager",
          "data-team",
        ],
        icon: HomeTwoToneIcon,
        link: "/preview/dashboards/analytics",
      },

      {
        name: "Admin Accounts",
        user_allowed: ["admin", "manager"],
        icon: SupervisorAccountTwoToneIcon,
        link: "/preview/dashboards/all-accounts",
      },

      {
        name: "Internal Treasury",
        user_allowed: ["admin", "tos"],
        icon: SavingsTwoTone,
        items: [
          {
            name: "Banks ",
            link: "/preview/dashboards/internal-treasury/banks",
          },
          {
            name: "Bank Accounts",
            link: "/preview/dashboards/internal-treasury/bank-accounts",
          },

          {
            name: "Balances",
            link: "/preview/dashboards/internal-treasury/balances",
          },
          {
            name: "Bank Transactions",
            link: "/preview/dashboards/internal-treasury/bank-transactions",
          },
          {
            name: "Transfers",
            link: "/preview/dashboards/internal-treasury/transfers",
          },
          {
            name: "Cash Positions",
            link: "/preview/dashboards/internal-treasury/cash-positions",
          },
        ],
      },
      {
        name: "Organizations",
        user_allowed: [
          "admin",
          "sales",
          "compliance",
          "finance",
          "presales_intern",
          "manager",
          "support",
          "finops",
        ],
        icon: BusinessTwoToneIcon,
        items: [
          {
            name: "All Organizations",
            link: "/preview/dashboards/organization",
          },
          {
            name: "Invite New Organization",
            link: "/preview/dashboards/invite-organization",
          },
          {
            name: "Offboarding",
            link: "/preview/dashboards/all-offboarding",
          },
        ],
      },
      {
        name: "Hierarchy",
        user_allowed: ["admin", "manager"],
        icon: AccountTreeIcon,
        items: [
          {
            name: "Setup",
            link: "/preview/dashboards/hierarchy",
          },
        ],
      },
      {
        name: "Partner",
        user_allowed: [
          "admin",
          "sales",
          "compliance",
          "finance",
          "finops",
          "presales_intern",
          "manager",
        ],
        icon: ContactsTwoTone,
        items: [
          {
            name: "All Partners",
            link: "/preview/dashboards/partner",
          },
          {
            name: "Commission Report",
            link: "/preview/dashboards/partner-commission-report",
          },
          {
            name: "Revenue Report",
            link: "/preview/dashboards/partner-revenue-report",
          },
        ],
      },
      {
        name: "Pending Actions",
        user_allowed: [
          "admin",
          "compliance",
          "presales_intern",
          "manager",
          "finops",
        ],
        icon: PendingActionsTwoToneIcon,
        items: [
          {
            name: "Settlement Bank",
            link: "/preview/dashboards/pending-actions/settlement-bank",
          },
          {
            name: "Pre Funding Accounts",
            link: "/preview/dashboards/pending-actions/prefunding-account",
          },
          {
            name: "Payment Method Setting",
            link: "/preview/dashboards/pending-actions/payment-method-setting",
          },
          {
            name: "Inbound Fund Notice",
            link: "/preview/dashboards/pending-actions/inbound-fund-notice",
          },
          {
            name: "Invest Account Activation",
            user_allowed: ["admin", "tos"],
            link: "/preview/dashboards/invest-account-activation",
          },
          {
            name: "Partner Org Feature Control",
            link:
              "/preview/dashboards/pending-actions/partner-org-feature-control",
          },
          // {
          //   name: "Payout Method",
          //   link: "/preview/dashboards/pending-actions/payout-method",
          // },
        ],
      },
      {
        name: "Compliance/AFCC",
        user_allowed: ["admin", "compliance", "manager"],
        icon: PolicyTwoTone,
        items: [
          {
            name: "Transaction Monitoring",
            link: "/preview/dashboards/transaction-monitoring/dashboard",
          },
          {
            name: "List Manager",
            link: "/preview/dashboards/list-manager/risky-words",
          },
          {
            name: "Daily Screening",
            link: "/preview/dashboards/daily-screening/alerts",
          },
          {
            name: "Customer Screening",
            link: "/preview/dashboards/customer-screening/alerts",
          },
        ],
      },
      {
        name: "Suspended Transactions",
        icon: PolicyTwoTone,
        user_allowed: ["admin", "compliance", "finops", "manager"],
        link: "/preview/dashboards/suspended-transactions",
      },
      {
        name: "Organization User",
        user_allowed: [
          "admin",
          "sales",
          "support",
          "finops",
          "compliance",
          "finance",
          "presales_intern",
          "manager",
        ],
        icon: AssignmentIndTwoToneIcon,
        items: [
          {
            name: "Organization Specific Users",
            link: "/preview/dashboards/user/orgs",
          },
          {
            name: "Impersonate Org Users",
            link: "/preview/dashboards/user/impersonate",
          },
          {
            name: "Session IP Location",
            link: "/preview/dashboards/user/all-session-ip-locations",
          },
        ],
      },
      {
        name: "KYB",
        user_allowed: [
          "admin",
          "sales",
          "compliance",
          "finance",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: VerticalSplitTwoToneIcon,
        items: [
          {
            name: "All Organizations",
            link: "/preview/dashboards/kyb/all-orgs",
          },
          {
            name: "All Applications",
            link: "/preview/dashboards/kyb",
          },
          {
            name: "Not Started",
            link: "/preview/dashboards/kyb/not-started",
          },
          {
            name: "Customer Submitted",
            link: "/preview/dashboards/kyb/cust-submitted",
          },
          {
            name: "In Review",
            link: "/preview/dashboards/kyb/in-review",
          },
          {
            name: "Conditionally Approved",
            link: "/preview/dashboards/kyb/conditionally-approved",
          },
          {
            name: "Approved",
            link: "/preview/dashboards/kyb/approved",
          },
          {
            name: "Rejected",
            link: "/preview/dashboards/kyb/rejected",
          },
          {
            name: "To Be Resubmitted",
            link: "/preview/dashboards/kyb/to-be-resubmitted",
          },
          {
            name: "Resubmitted",
            link: "/preview/dashboards/kyb/resubmitted",
          },
        ],
      },
      {
        name: "Contract",
        user_allowed: [
          "admin",
          "sales",
          "compliance",
          "finance",
          "support",
          "finops",
          "presales_intern",
          "manager",
        ],
        icon: AssignmentTwoToneIcon,
        link: "/preview/dashboards/contract/orgs",
      },
      {
        name: "Org Documents",
        user_allowed: ["admin", "compliance", "support", "manager"],
        icon: ArticleTwoToneIcon,
        items: [
          {
            name: "All Organizations",
            link: "/preview/dashboards/documents/orgs",
          },
        ],
      },
      {
        name: "Connector",
        user_allowed: ["admin", "compliance", "support", "manager"],
        icon: SettingsEthernetTwoToneIcon,
        items: [
          {
            name: "New Connector",
            link: "/preview/dashboards/connector",
          },
          {
            name: "All Connectors",
            link: "/preview/dashboards/all-connectors",
          },
          {
            name: "Key Connector Map",
            link: "/preview/dashboards/connector/key-connector-map",
          },
          {
            name: "Purpose Code Mapping",
            link: "/preview/dashboards/connector/purpose-code-mapping",
          },
        ],
      },
      {
        name: "Global Liquidity Engine",
        user_allowed: ["admin", "finance", "support", "manager"],
        icon: RequestQuoteTwoToneIcon,
        items: [
          {
            name: "GLE Dashboard",
            link: "/preview/dashboards/global-liquidity-engine/dashboard",
          },
          {
            name: "Entity Currency Balances",
            link:
              "/preview/dashboards/global-liquidity-engine/entity-currency-balances",
          },
          {
            name: "Safegaurding Config",
            link:
              "/preview/dashboards/global-liquidity-engine/safegaurding-config",
          },
          {
            name: "Connector Currency Balances",
            link:
              "/preview/dashboards/global-liquidity-engine/connector-currency-balances",
          },
          {
            name: "Cash Positions",
            link: "/preview/dashboards/global-liquidity-engine/cash-positions",
          },
        ],
      },
      {
        name: "Org Connector Config",
        user_allowed: [
          "admin",
          "compliance",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: ViewAgendaTwoTone,
        items: [
          {
            name: "New Connector Config",
            link: "/preview/dashboards/new-org-connector-config",
          },
          {
            name: "All Connector Configs",
            link: "/preview/dashboards/all-org-connector-configs",
          },
          {
            name: "All Organizations",
            link: "/preview/dashboards/org-connector-config/orgs",
          },
        ],
      },
      {
        name: "Payin Method Config",
        user_allowed: [
          "admin",
          "compliance",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: AccountTreeTwoTone,
        items: [
          {
            name: "New Payin Method Config",
            link: "/preview/dashboards/new-payin-method-config",
          },
          {
            name: "All Payin Method Configs",
            link: "/preview/dashboards/all-payin-method-configs",
          },
          {
            name: "All Organizations",
            link: "/preview/dashboards/payin-method-config/orgs",
          },
        ],
      },
      {
        name: "Payin Method",
        user_allowed: ["admin", "compliance", "support", "manager"],
        icon: ArrowCircleDownTwoToneIcon,
        items: [
          {
            name: "New Payin Method",
            link: "/preview/dashboards/payin-method",
          },
          {
            name: "All Payin Methods",
            link: "/preview/dashboards/all-payin-methods",
          },
        ],
      },
      {
        name: "Payout Method",
        user_allowed: [
          "admin",
          "compliance",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: ArrowCircleUpTwoToneIcon,
        items: [
          {
            name: "New Payout Method",
            link: "/preview/dashboards/payout-method",
          },
          {
            name: "All Payout Methods",
            link: "/preview/dashboards/all-payout-methods",
          },
        ],
      },
      // {
      //   name: "Transaction Monitoring",
      //   icon: PaymentTwoToneIcon,
      //   items: [
      //     {
      //       name: "Add New Rule",
      //       link: "/preview/dashboards/transaction-rules/new-transaction-rule",
      //     },
      //     {
      //       name: "All Transaction Rules",
      //       link: "/preview/dashboards/transaction-rules/all-transaction-rules",
      //     },
      //   ],
      // },
      {
        name: "Pricing",
        user_allowed: [
          "admin",
          "compliance",
          "finops",
          "finance",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: ReceiptTwoToneIcon,
        items: [
          {
            name: "Pricing Setup",
            items: [
              {
                name: "Create Pricing Setup",
                link: "/preview/dashboards/pricing/pricing-setup/create",
              },
              {
                name: "All Pricing Setup",
                link: "/preview/dashboards/pricing/pricing-setup",
              },
            ],
          },
          {
            name: "Plans",
            link: "/preview/dashboards/pricing/plans",
          },
          {
            name: "Plan Association",
            link: "/preview/dashboards/pricing/plan-association",
          },
          {
            name: "Country Plan - Default",
            link: "/preview/dashboards/pricing/country-plan",
          },
          {
            name: "Tax Config",
            items: [
              {
                name: "Country Tax",
                link: "/preview/dashboards/pricing/country-tax",
              },
              {
                name: "Organization Tax",
                link: "/preview/dashboards/pricing/organization-tax",
              },
            ],
          },
          {
            name: "Monthly Minimum",
            link: "/preview/dashboards/pricing/monthly-minimum",
          },
          {
            name: "Recurring Fees",
            link: "/preview/dashboards/pricing/recurring-fees",
          },
          {
            name: "Payin Method Pricing",
            link: "/preview/dashboards/pricing/payin-method-pricing",
          },
          {
            name: "Payout Method Pricing",
            link: "/preview/dashboards/pricing/payout-method-pricing",
          },
          {
            name: "Fx Conversion Markup",
            link: "/preview/dashboards/pricing/fx-conversion-markup",
          },
          {
            name: "Org Pricing - At a glance",
            link: "/preview/dashboards/pricing/organizations",
          },
          {
            name: "Cost Configuration",
            link: "/preview/dashboards/pricing/cost-config",
          },
        ],
      },
      {
        name: "Invoice",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "compliance",
          "invoice",
          "finance",
          "manager",
        ],
        icon: DescriptionTwoToneIcon,
        items: [
          {
            name: "Invoice Dashboard",
            link: "/preview/dashboards/invoice/dashboard",
          },
          {
            name: "Invoice at a Glance",
            link: "/preview/dashboards/invoice/overview",
          },
          {
            name: "Invoice Org Config",
            link: "/preview/dashboards/invoice/invoice-config",
          },
          {
            name: "All Organizations",
            link: "/preview/dashboards/invoice/orgs",
          },
        ],
      },
      {
        name: "Virtual Account",
        user_allowed: ["admin", "support", "finops", "compliance", "manager"],
        icon: SwitchAccountTwoToneIcon,
        link: "/preview/dashboards/virtual-accounts",
      },
      {
        name: "Payins",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "compliance",
          "sales",
          "manager",
        ],
        icon: TollTwoToneIcon,
        link: "/preview/dashboards/all-payins",
      },
      {
        name: "Refunds",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "compliance",
          "sales",
          "manager",
        ],
        icon: RotateLeftIcon,
        link: "/preview/dashboards/all-refunds",
      },
      {
        name: "Payouts",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "compliance",
          "sales",
          "manager",
        ],
        icon: PaymentsTwoToneIcon,
        items: [
          {
            name: "All Payouts",
            link: "/preview/dashboards/all-payouts",
          },
          {
            name: "Purpose Code",
            link: "/preview/dashboards/payout/purpose-code",
          },
        ],
      },
      {
        name: "Transfers",
        user_allowed: ["admin", "finance", "finops", "manager"],
        icon: TrendingFlatIcon,
        items: [
          {
            name: "All Transfers",
            link: "/preview/dashboards/transfers",
          },
          {
            name: "Connector Map",
            link: "/preview/dashboards/transfers/connector-map",
          },
          {
            name: "Routing Preview",
            link: "/preview/dashboards/transfers/connector-map/routing-preview",
          },
        ],
      },
      {
        name: "FX Conversion",
        user_allowed: ["admin", "compliance", "finance", "finops", "manager"],
        icon: PriceChangeIcon,
        link: "/preview/dashboards/fx-conversion",
      },
      {
        name: "Checkout",
        user_allowed: ["admin", "support", "finops", "compliance", "manager"],
        icon: ConfirmationNumberTwoToneIcon,
        link: "/preview/dashboards/all-checkouts",
      },
      {
        name: "Adjustment",
        user_allowed: ["admin", "compliance", "finance", "finops", "manager"],
        icon: MonetizationOnTwoToneIcon,
        link: "/preview/dashboards/all-adjustments",
      },
      {
        name: "Fees Adjustment",
        user_allowed: ["admin", "compliance", "finance", "finops", "manager"],
        icon: MonetizationOnTwoToneIcon,
        link: "/preview/dashboards/all-fees-adjustments",
      },
      {
        name: "Customer",
        user_allowed: [
          "admin",
          "compliance",
          "finance",
          "finops",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: AccountCircleTwoToneIcon,
        link: "/preview/dashboards/all-customers",
      },
      {
        name: "Wallet",
        user_allowed: [
          "admin",
          "compliance",
          "finance",
          "support",
          "manager",
          "finops",
        ],
        icon: AccountBalanceWalletTwoToneIcon,
        link: "/preview/dashboards/all-wallets",
      },
      {
        name: "Wallet Fund Transfer",
        user_allowed: ["admin", "compliance", "finance", "finops", "manager"],
        icon: ShareTwoToneIcon,
        items: [
          {
            name: "New WFT",
            link: "/preview/dashboards/new-wallet-fund-transfer",
          },
          {
            name: "All WFT",
            link: "/preview/dashboards/all-wallet-fund-transfers",
          },
          // {
          //   name: "Organization Specific",
          //   link: "/preview/dashboards/wallet/orgs",
          // },
          {
            name: "Organization Specific",
            link: "/preview/dashboards/wallet-fund-transfer/orgs",
          },
        ],
      },
      {
        name: "Reconciliation",
        user_allowed: ["admin", "support", "finops", "finance", "manager"],
        icon: ReceiptLong,
        link: "/preview/dashboards/reconciliation-job",
      },
      {
        name: "Settlements",
        user_allowed: ["admin", "support", "finops", "finance", "manager"],
        icon: AutorenewTwoToneIcon,
        items: [
          {
            name: "All Settlements",
            link: "/preview/dashboards/all-settlements",
          },
          {
            name: "All Organizations",
            link: "/preview/dashboards/settlement/orgs",
          },
          {
            name: "Settlement Summary",
            link: "/preview/dashboards/settlement-payout-details",
          },
        ],
      },
      {
        name: "Transactions",
        user_allowed: [
          "admin",
          "compliance",
          "sales",
          "finops",
          "finance",
          "support",
          "manager",
        ],
        link: "/preview/dashboards/transactions",
        icon: PaymentTwoToneIcon,
      },
      {
        name: "Stable Coin",
        user_allowed: ["admin", "finance", "support", "compliance", "finops"],
        icon: MonetizationOnTwoToneIcon,
        items: [
          {
            name: "Stable Transactions",
            link: "/preview/dashboards/stables-transaction",
          },
          {
            name: "Provider",
            link: "/preview/dashboards/provider",
          },
        ],
      },
      {
        name: "Audit Trail",
        user_allowed: ["admin", "compliance", "support", "manager"],
        icon: TimelineTwoTone,
        items: [
          {
            name: "All Organizations",
            link: "/preview/dashboards/audit-trail/orgs",
          },
          {
            name: "All Partners",
            link: "/preview/dashboards/audit-trail/partners",
          },
          {
            name: "Backoffice",
            link: "/preview/dashboards/bo-audit-trail",
          },
        ],
      },
      {
        name: "Org Balance at a Glance",
        user_allowed: [
          "admin",
          "finance",
          "support",
          "manager",
          "finops",
          "compliance",
        ],
        icon: RequestQuoteTwoToneIcon,
        link: "/preview/dashboards/org-balance-at-glance",
      },

      {
        name: "Org Txns at a Glance",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "compliance",
          "sales",
          "finance",
          "manager",
        ],
        icon: CorporateFareTwoToneIcon,
        link: "/preview/dashboards/org-at-glance/orgs",
      },
      {
        name: "Org Control at a Glance",
        user_allowed: [
          "admin",
          "compliance",
          "support",
          "finops",
          "presales_intern",
          "manager",
        ],
        icon: TuneTwoTone,
        link: "/preview/dashboards/org-control-at-glance/orgs",
      },
      {
        name: "Limit at a Glance",
        user_allowed: ["admin", "compliance", "manager"],
        icon: TuneTwoTone,
        items: [
          {
            link: "/preview/dashboards/org-limit-at-glance/active-keys",
            name: "Active Keys",
          },
          {
            link: "/preview/dashboards/org-limit-at-glance/platform",
            name: "Platform Level",
          },
          {
            link: "/preview/dashboards/org-limit-at-glance/orgs",
            name: "Org Level",
          },
        ],
      },
      {
        name: "Partner Control at a Glance",
        user_allowed: [
          "admin",
          "compliance",
          "sales",
          "support",
          "presales_intern",
          "manager",
        ],
        icon: ManageAccountsTwoTone,
        link: "/preview/dashboards/partner-control-at-a-glance/all-partners",
      },
      {
        name: "Broadcast Email",
        user_allowed: ["admin", "support", "manager"],
        icon: CampaignTwoTone,
        link: "/preview/dashboards/broadcast-email",
      },
      {
        name: "Transaction Lookup",
        user_allowed: [
          "admin",
          "support",
          "finops",
          "compliance",
          "finance",
          "manager",
        ],
        icon: ManageSearchTwoTone,
        items: [
          {
            name: "Transaction Lookup",
            link: "/preview/dashboards/transaction-lookup",
          },
          {
            name: "Disputed Transactions",
            link: "/preview/dashboards/disputed-transactions",
          },
        ],
      },
      {
        name: "Regulatory Reporting",
        user_allowed: ["admin", "manager", "finops", "compliance"],
        icon: AssessmentIcon,
        // link: "/preview/dashboards/regulatory-reporting",
        items: [
          {
            name: "IFTI Reporting",
            items: [
              {
                name: "IFTI Incoming",
                link: "/preview/dashboards/regulatory-reporting/ifti-incoming",
              },
              {
                name: "IFTI Outgoing",
                link: "/preview/dashboards/regulatory-reporting/ifti-outgoing",
              },
            ],
          },
          {
            name: "MAS Reporting",
            items: [
              {
                name: "MAS Monthly",
                link:
                  "/preview/dashboards/regulatory-reporting/mas-reporting/MONTHLY",
              },
            ],
          },
        ],
      },
      {
        name: "Job Scheduler",
        user_allowed: ["admin", "manager"],
        icon: TimelapseTwoTone,
        items: [
          {
            name: "All Scheduler Repositories",
            link: "/preview/dashboards/all-scheduler-repositories",
          },
          {
            name: "Create Job Scheduler",
            link: "/preview/dashboards/create-job-scheduler",
          },
        ],
      },
      {
        name: "Investment Product",
        user_allowed: ["admin", "manager"],
        icon: SavingsTwoTone,
        link: "/preview/dashboards/investment-product",
      },
      {
        name: "Global FX Engine",
        user_allowed: ["admin", "manager"],
        icon: MonetizationOnTwoToneIcon,
        link: "/preview/dashboards/global-payout-engine",
        items: [
          {
            name: "FX Positions",
            link: "/preview/dashboards/fx-positions",
          },
          {
            name: "FX Netting Transactions",
            link: "/preview/dashboards/fx-netting-transactions",
          },
          {
            name: "Fx Conversion Configuration Rules",
            link: "/preview/dashboards/global-payout-engine/fx-conversion-rule",
          },
        ],
      },
      {
        name: "Data Nova",
        user_allowed: ["data-team"],
        icon: SchemaTwoToneIcon,
        link: "/preview/dashboards/data-nova",
      },
      {
        name: "Webhook Notifications",
        user_allowed: ["admin", "manager"],
        icon: WebhookTwoTone,
        link: "/preview/dashboards/webhook-notification",
      },
    ],
  },
];

export default menuItems;
